import React from 'react';
import styled from 'styled-components'
import imge from '../../img/fondoHeader.jpg'

const Background = styled.div`
    background-image: url(${imge});
    height: 80vh;
    background-position: top center; 
    background-size: cover;
    position: relative; 
`;
const Titulo = styled.div`
    position: absolute;
    top: 40px;
    left: 50px;
    h2 { 
        color: #e6dfdb; 
        font-size: 50px;
        width: 60%;
        text-align: justify;
    } 

    h1 { 
        color: #e6dfdb;
        font-size: 25px; 
        text-align: left;
    }
    @media (max-width: 968px) {
        h2 {
            font-size: 35px;
            width: 87%; 
        }
     
    }
    
`;

const Header = () => {
    return ( 
        <Background>
            <Titulo>
                <h2 className="titulo">Delimitador de techos para el uso de paneles fotovoltaicos construido con vision artificial y machine learning</h2> 
                <h1>por Gean Carlo Vitorino Monjaras</h1>
            </Titulo>
        </Background>
    );
}
 
export default Header;